import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withStyles } from '@material-ui/core';
import BaseComp from '../BaseComponent';
import styles from './styles';

function Adaptable({
                       classes, className,
                       hideExtraSmall, hideSmall, hideMedium, hideLarge, hideFromSmallUp, hideFromMediumUp,
                       hideFromSmallDown, hideFromMediumDown, hideFromLargeDown,
                       ...rest
                   }) {
    return <BaseComp {...rest} className={cn(classes.adaptable, className, {
        hideExtraSmall,
        hideSmall,
        hideMedium,
        hideLarge,
        hideFromSmallUp,
        hideFromMediumUp,
        hideFromSmallDown,
        hideFromMediumDown,
        hideFromLargeDown,
    })}/>;
}

Adaptable.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
};

export default withStyles(styles)(Adaptable);
